import RelatorioTecnico from './componentes/RelatorioTecnicoProjeto.vue';
import RelatorioTecnicoLista from './componentes/RelatorioTecnicoProjetoLista.vue';
import RelatorioTecnicoForm from './componentes/RelatorioTecnicoProjetoForm.vue';
import FormPlanoTrabalhoForm from './componentes/FormPlanoTrabalhoForm.vue';
import RelatorioTecnicoEquipe from './componentes/RelatorioTecnicoProjetoEquipe.vue';
import RelatorioTecnicoProjetoAquisicoes from './componentes/RelatorioTecnicoProjetoAquisicoes.vue';


export default {
  path: '/relatorio-tecnico-projeto',
  component: RelatorioTecnico,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: RelatorioTecnicoLista,
      name: 'relatorio-tecnico-projeto',
    },
    {
      path: ':id',
      component: RelatorioTecnicoForm,
      name: 'relatorio-tecnico-projeto.editar'
    },
    {
      path: ':id',
      component: FormPlanoTrabalhoForm,
      name: 'relatorio-tecnico-projeto.planotrabalho'
    },
    {
      path: ':id',
      component: RelatorioTecnicoEquipe,
      name: 'relatorio-tecnico-projeto.planotrabalhoequipe'
    },
    {
      path: ':id',
      component: RelatorioTecnicoProjetoAquisicoes,
      name: 'relatorio-tecnico-projeto.planotrabalhoaquisicoes'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/relatorio-tecnico-projeto/rotas.js